// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__ikWJZ","full-page-modal__dialog":"Modal_full-page-modal__dialog__d1uEE","full-page-modal__content":"Modal_full-page-modal__content__R_L_r"};